import { render } from "./StorefrontOrderPayment.vue?vue&type=template&id=d6c318e0&scoped=true"
import script from "./StorefrontOrderPayment.vue?vue&type=script&lang=js"
export * from "./StorefrontOrderPayment.vue?vue&type=script&lang=js"

import "./StorefrontOrderPayment.vue?vue&type=style&index=0&id=d6c318e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6c318e0"]])

export default __exports__